import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { createImmutableObjectClass } from 'immutable-less';
import produce from 'immer';
const FieldMappingDefaults = {
  fieldType: null,
  appField: null,
  hubSpotField: null
};
export default class FieldMapping extends createImmutableObjectClass(FieldMappingDefaults, {
  fromJSON: _ref => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    return Object.assign({}, rest, {
      fieldType: rest.fieldType
    });
  },
  toJSON: _ref2 => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return Object.assign({}, rest);
  }
}) {
  isValid() {
    return this.get('appField') && (this.get('fieldType') === 'CUSTOM' || this.get('hubSpotField'));
  }
  isBlank() {
    return !this.get('appField') && !this.get('hubSpotField');
  }
  updateFieldMapping(updates) {
    return produce(this, fieldMappingDraft => {
      Object.entries(updates).forEach(([key, value]) => {
        fieldMappingDraft.set(key, value);
      });
    });
  }
}